export default __webpack_public_path__ + "static/media/honeywood_logo_bw.2b146111.png";